import * as t from './action_types';

import common from '@common';

const { ORDER_VALUES } = common.utils.table;

export const initialState = {
  areMapPeopleLoading: false,
  areMapPropertiesLoading: false,
  dashboardSwitchIsVisible: true,
  dashboardVersion: 'v1',
  dateActivity: 'any',
  isError: false,
  isLoading: false,
  isLoadingMore: false,
  orderBy: 'home_id',
  orderValue: ORDER_VALUES.ASC,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case t.DASHBOARD_START_LOADING_PROPERTIES:
      return {
        ...state,
        isError: false,
        isLoading: true,
      };
    case t.DASHBOARD_STOP_LOADING_PROPERTIES:
      return {
        ...state,
        isLoading: false,
      };
    case t.DASHBOARD_START_LOADING_MORE_PROPERTIES:
      return {
        ...state,
        isLoadingMore: true,
      };
    case t.DASHBOARD_STOP_LOADING_MORE_PROPERTIES:
      return {
        ...state,
        isLoadingMore: false,
      };
    case t.DASHBOARD_SET_PROPERTIES_ERROR:
      return {
        ...state,
        isError: true,
      };
    case t.DASHBOARD_SET_VERSION:
      return {
        ...state,
        dashboardVersion: action.payload,
      };
    case t.DASHBOARD_SET_SWITCH_VISIBILITY:
      return {
        ...state,
        dashboardSwitchIsVisible: action.payload,
      };
    case t.DASHBOARD_CHANGE_DATE_ACTIVITY:
      return {
        ...state,
        dateActivity: action.payload,
      };
    case t.DASHBOARD_CHANGE_ORDER: {
      const { orderBy, orderValue } = action.payload;
      return {
        ...state,
        orderBy,
        orderValue,
      };
    }
    case t.DASHBOARD_RESET_DASHBOARD_OPTIONS: {
      return initialState;
    }
    case t.MAP_DASHBOARD_START_LOADING_PEOPLE:
      return {
        ...state,
        areMapPeopleLoading: true,
      };
    case t.MAP_DASHBOARD_STOP_LOADING_PEOPLE:
      return {
        ...state,
        areMapPeopleLoading: false,
      };
    case t.MAP_DASHBOARD_START_LOADING_PROPERTIES:
      return {
        ...state,
        areMapPropertiesLoading: true,
      };
    case t.MAP_DASHBOARD_STOP_LOADING_PROPERTIES:
      return {
        ...state,
        areMapPropertiesLoading: false,
      };
    default:
      return state;
  }
};
